import axios from 'axios'
import TransactionNotFoundError from './errors/TransactionNotFoundError'
import Transaction from './models/Transaction'

const MAX_QRCODE_POOLING_RETRIES = Number(process.env.VUE_APP_QRCODE_POOLING_RETRIES)
const QRCODE_POOLING_INTERVAL = Number(process.env.VUE_APP_QRCODE_POOLING_INTERVAL)

const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_PIXIE_BASE_URL
})

const callQRCodeAPI = async (transactionId) => {
  try {
    const { data } = await httpClient.get(`${transactionId}/qrcode`)
    return new Transaction(data)
  } catch (error) {
    const { status } = error?.response
    if (status && (status === 404)) {
      throw new TransactionNotFoundError(transactionId)
    }

    throw error
  }
}

const getQRCode = async (transactionId) => {
  let retries = 0
  let error = new Error('unknown error')

  while (retries < MAX_QRCODE_POOLING_RETRIES) {
    try {
      return await callQRCodeAPI(transactionId)
    } catch (err) {
      error = err
    }

    await sleep(QRCODE_POOLING_INTERVAL)
    retries++
  }

  throw error
}

export { getQRCode }
